<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="dane">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>Logowanie</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-12" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <div class="input-group mb-3">
              <input
                v-model.trim="user"
                type="text"
                name="username"
                autocomplete="username"
                v-on:keydown.enter="onLoginButtonClick"
                class="form-control"
                placeholder="Nazwa użytkownika"
                required
              />
            </div>
            <div class="input-group mb-1" style="height: 1.5rem">
              <input
                v-model.trim="password"
                name="password"
                autocomplete="current-password"
                v-on:keydown.enter="onLoginButtonClick"
                :type="passwordType"
                class="form-control"
                placeholder="Hasło"
                required
              />
              <img
                :src="eyeImage"
                @click="togglePasswordView"
                class="imageTogglePasswordOld"
                alt=""
              />
            </div>
            <div class="form-check text-start mt-3">
              <input
                v-model="rememberUser"
                class="form-check-input checkbox-blue"
                type="checkbox"
                value=""
                id="rememberUserCheck"
              />
              <label class="form-check-label" for="rememberUserCheck">
                Zapamiętaj mnie
              </label>
            </div>
            <Alert
              v-if="dataInvalidInfo"
              :key="alertKey"
              alert-type="alert-danger"
              alert-text="Wprowadź poprawne dane!"
            />
            <Alert
              v-if="userRegNotConfirmedInfo"
              :key="alertKey"
              alert-type="alert-danger"
              alert-text="Użytkownik nie potwierdził rejestracji."
            />
            <Alert
              v-if="generalErrorInfo"
              :key="alertKey"
              alert-type="alert-danger"
              alert-text="Wystąpił błąd serwera. Skontaktuj się z pomoca techniczną."
            />
            <div class="text-center">
              <button
                type="button"
                id="logButton"
                class="btn-standard m-2"
                @click="onLoginButtonClick"
              >
                Zaloguj
              </button>
            </div>
            <div class="col text-center mt-4">
              <router-link :to="registrationPath"
                ><button type="button" id="regButton" class="btn-standard">
                  <b>Chcę się zarejestrować</b>
                </button></router-link
              >
              <router-link :to="resetPasswordPath"
                ><button
                  type="button"
                  id="resetPassButton"
                  class="btn-standard"
                >
                  <b>Zapomniałem hasła</b>
                </button></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <Footer />
</template>

<script>
import Alert from "@/components/Alert.vue";
import { RequestResult } from "@/utils/requestResult";
import { RoutePath } from "@/utils/routePath";
import { makeRequest, scrollToTop } from "@/utils/helpers";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "HomeView",

  components: {
    Navbar,
    Footer,
    Alert,
  },

  computed: {
    eyeImage() {
      return this.eyeImgClicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg"; // UWAGA: obrazki w folderze img w repo, nie ma ich w source/src/assets bo się nie chcą dodawać do builda dynamicznie
    },
  },

  data() {
    return {
      user: "",
      password: "",
      rememberUser: null, // zależne od expire'a ciasteczka? => nie, to tylko ustawia datę w ciasteczku, nic więcej

      dataInvalidInfo: false,
      userRegNotConfirmedInfo: false,
      generalErrorInfo: false,

      alertKey: 0,

      registrationPath: RoutePath.Registration,
      resetPasswordPath: RoutePath.ResetPassword,

      passwordType: "password",
      eyeImgClicked: false,
    };
  },

  watch: {
    rememberUser(value) {
      localStorage.setItem("nexRentalRememberUser", value);
    },
  },

  async mounted() {
    scrollToTop();

    this.rememberUser = localStorage.getItem("nexRentalRememberUser");
    // wysyłamy getUser, wtedy na serwerze sprawdzane jest ciasteczko i przekierujemy na /home jeśli jest OK
    await this.getUserData();
  },

  methods: {
    togglePasswordView() {
      if (this.passwordType === "password") this.passwordType = "text";
      else this.passwordType = "password";

      this.eyeImgClicked = !this.eyeImgClicked;
    },

    async getUserData() {
      let data = {
        action: this.request.GetUser,
      };

      let getUserResponse = await makeRequest(data);

      switch (getUserResponse.data.error) {
        case RequestResult.OK: {
          this.$router.push(this.routePath.Home);
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          // nic nie rób
          break;
        }
        case RequestResult.GeneralError: {
          this.generalErrorInfo = true;
          break;
        }
      }

      this.alertKey += 1;
    },

    async onLoginButtonClick() {
      this.dataInvalidInfo = false;
      this.userRegNotConfirmedInfo = false;

      let data = {
        action: this.request.Login,
        usr: this.user,
        pass: this.password,
        rememberme: this.rememberUser,
      };

      let loginRequestResponse = await makeRequest(data);

      switch (loginRequestResponse.data.error) {
        case RequestResult.OK: {
          this.$router.push(this.routePath.Home);
          break;
        }
        case RequestResult.InvalidLoginData:
        case RequestResult.InvalidOrMissingParameter: {
          this.dataInvalidInfo = true;
          break;
        }
        case RequestResult.UserRegNotConfirmed: {
          this.userRegNotConfirmedInfo = true;
          break;
        }
        case RequestResult.GeneralError: {
          this.generalErrorInfo = true;
          break;
        }
      }

      this.alertKey += 1;
    },
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
